export const GET_COMPANIES_WITH_FEED_ACCESS = 'GET_COMPANIES_WITH_FEED_ACCESS';
export const SET_COMPANIES_WITH_FEED_ACCESS = 'SET_COMPANIES_WITH_FEED_ACCESS';
export const SET_SELECTED_COMPANY = 'SET_SELECTED_COMPANY';
